<template>
  <header class="sticky-top header-bar">
    <div class="header_title text-center py-2">
      {{ $t('header.title') }}
    </div>
    <div class="lang-switch">
      <div class="btn-group btn-group-sm" role="group" aria-label="Language">
        <button
          type="button"
          class="btn btn-lang"
          :class="{ active: currentLocale === 'ja' }"
          @click="selectLang('ja')"
        >
          JA
        </button>
        <button
          type="button"
          class="btn btn-lang"
          :class="{ active: currentLocale === 'en' }"
          @click="selectLang('en')"
        >
          EN
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { i18nState, setLocale } from '@/locales';

export default {
  name: 'HeaderBar',
  computed: {
    currentLocale() {
      return i18nState.locale;
    }
  },
  methods: {
    selectLang(lang) {
      setLocale(lang);
    }
  }
};
</script>

<style scoped lang="scss">
.header-bar {
  position: sticky;
  top: 0;
  z-index: 1020;
  background-color: darkblue;
}

.header_title {
  font-size: 1.5em;
  font-weight: bold;
  background-color: darkblue;
  color: #ffffff;
  padding-left: 75px;
  padding-right: 75px;
  margin: 0;
  line-height: 1.4;
  word-break: keep-all;
}

.lang-switch {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.btn-lang {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.6);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 2px 8px;
  background-color: transparent;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    color: #ffffff;
    border-color: #ffffff;
  }

  &.active {
    background-color: #ffffff;
    color: darkblue;
    border-color: #ffffff;
  }
}

@media (max-width: 576px) {
  .header_title {
    font-size: 1.05em;
    padding-left: 65px;
    padding-right: 65px;
  }
  .btn-lang {
    font-size: 0.7rem;
    padding: 1px 6px;
  }
}
</style>
